export default {
  title: "Account",
  collections: "Collections",
  savedQueries: "Saved queries",
  newCollection: "New collection",
  collectionTitle: "Title",
  collectionDescription: "Description",
  isPublic: "Public collection",
  items: "{{count}} items",
  emptyCollections: "No collections yet. Create one to save catalogue cards.",
  emptyQueries: "No saved queries.",
  runQuery: "Open",
  subscribe: "Notify me of updates",
  kindSearch: "Search",
  kindSparql: "SPARQL",
  deleteCollection: "Delete this collection?",
  deleteQuery: "Delete this saved query?",
  deleteQueryFailed: "Could not delete the saved query. It remains available.",
  hello: "Hello, {{name}}",
  portal: {
    pageTitle: "Personal account",
    pageSubtitle: "Russian State Library portal: services and participant profile.",
    navAria: "Personal account sections",
    overviewNav: "Overview",
    welcome: "Hello, {{name}}!",
    welcomeHint: "Manage your profile, notifications and library services from here.",
    completionLabel: "Completed: {{percent}}%",
    profileComplete: "Your profile is complete",
    completionProgressAria: "Profile completion",
    servicesTitle: "Portal services",
    services: {
      events: { title: "Events", desc: "Programme, registration and event materials." },
      deposit: { title: "Deposits", desc: "Submit works and follow deposit applications." },
      admin: { title: "Administration", desc: "Roles and users — only with the matching permissions." },
    },
    anketaHint: "Tell us about yourself so we can suggest relevant events.",
    completionMissingTitle: "Still to complete",
    completionMissingGoAria: "Go to: {{label}}",
  },
  tabs: {
    personal: "My details",
    education: "Education",
    languages: "Languages",
    work: "Work",
    portfolio: "Portfolio",
    creative: "Self-definition",
    accounts: "Accounts",
    collections: "Collections",
    notifications: "Notifications",
  },
  languages: {
    title: "Languages",
    code: "Language code",
    level: "Level",
    add: "Add",
    empty: "No languages yet.",
  },
  work: {
    title: "Work",
    organization: "Organization",
    position: "Position",
    add: "Add",
    empty: "No work experience yet.",
  },
  portfolio: {
    title: "Portfolio",
    itemTitle: "Title",
    url: "URL",
    add: "Add",
    empty: "No achievements yet.",
  },
  creative: {
    title: "Self-definition",
    empty: "The role catalogue is empty.",
    loadFailed: "Could not load self-definition.",
    current: "Current profile values",
    direction: "Direction",
    subdirection: "Subdirection",
    role: "Role",
  },
  accounts: {
    title: "Accounts",
    email: "Email",
    displayName: "Display name",
    hint: "Split full name and profile PDF will appear once nbr-api exposes those fields.",
  },
  password: {
    title: "Change password",
    action: "Change password",
    changed: "Your password has been changed.",
    currentInvalid: "The current password is incorrect.",
    failed: "The password could not be changed.",
  },
  profile: {
    title: "Profile",
    bio: "About me",
    phone: "Phone",
    city: "City",
    save: "Save profile",
    saved: "Profile saved",
    loadFailed: "Could not load profile.",
    saveFailed: "Could not save profile.",
  },
  education: {
    title: "Education",
    institution: "Institution",
    specialty: "Specialty",
    add: "Add",
    empty: "No education entries yet.",
    delete: "Delete",
  },
  notifications: {
    title: "Notifications",
    empty: "No notifications.",
    unread: "Unread",
    markRead: "Mark read",
    loadFailed: "Could not load notifications.",
    open: "Open notifications",
  },
  links: {
    eventsPortal: "Events portal",
    depositsPortal: "Deposits portal",
    notifications: "Notifications",
  },
}
